/*
 * @Description: mutation-types
 * @Date: 2021-11-04 11:02:45
 * @LastEditTime: 2022-02-15 18:07:46
 */
// 设置sdkAppId
export const SET_SDK_APP_ID = 'SET_SDK_APP_ID';
// 设置userSig
export const SET_USER_SIG = 'SET_USER_SIG';
// 设置播放域名
export const SET_PLAYER_DOMAIN = 'SET_PLAYER_DOMAIN';
// 设置房间ID
export const SET_ROOM_ID = 'SET_ROOM_ID';
// 更新房间信息
export const SET_ROOM_NAME = 'SET_ROOM_NAME';
// 更新直播类型（横屏 ｜ 竖屏）
export const UPDATE_SCREEN_TYPE = 'UPDATE_SCREEN_TYPE';
// 更新用户信息
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
// 更新主播用户ID
export const SET_ANCHOR_USER_ID = 'SET_ANCHOR_USER_ID';
// 更新房间阶段
export const UPDATE_LIVE_STAGE = 'UPDATE_LIVE_STAGE';
// 更新播放线路
export const UPDATE_LINE_TYPE = 'UPDATE_LINE_TYPE';
// 更新播放状态
export const UPDATE_PLAY_STATE = 'UPDATE_PLAY_STATE';
// 更新使用的摄像头设备
export const UPDATE_ACTIVE_CAMERA = 'UPDATE_ACTIVE_CAMERA';
// 更新使用的麦克风设备
export const UPDATE_ACTIVE_MICROPHONE = 'UPDATE_ACTIVE_MICROPHONE';
// 更新使用的扬声器设备
export const UPDATE_ACTIVE_SPEAKER = 'UPDATE_ACTIVE_SPEAKER';
// 更新是否设置本地流镜像
export const UPDATE_SET_MIRROR = 'UPDATE_SET_MIRROR';
// 更新视频Profile
export const UPDATE_VIDEO_PROFILE = 'UPDATE_VIDEO_PROFILE';
// 更新是否开启美颜
export const UPDATE_OPEN_BEAUTY = 'UPDATE_OPEN_BEAUTY';
// 更新美颜参数
export const UPDATE_BEAUTY_PARAM = 'UPDATE_BEAUTY_PARAM';
// 更新是否录制直播
export const UPDATE_RECORD_LIVE = 'UPDATE_RECORD_LIVE';
// 更新是否采集视频状态
export const UPDATE_VIDEO_STATE = 'UPDATE_VIDEO_STATE';
// 更新是否采集视频状态
export const UPDATE_AUDIO_STATE = 'UPDATE_AUDIO_STATE';
// 更新音量大小
export const UPDATE_AUDIO_LEVEL = 'UPDATE_AUDIO_LEVEL';
// 更新上行网络质量登记
export const UPDATE_UPLINK_NETWORK_LEVEL = 'UPDATE_UPLINK_NETWORK_LEVEL';
// 更新横竖屏状态
export const UPDATE_LAYOUT = 'UPDATE_LAYOUT';
// 设置当前浏览器是否支持 WebRTC
export const SET_IS_SUPPORT_WEBRTC = 'SET_IS_SUPPORT_WEBRTC';
// 设置用户权限
export const SET_PRIVILEGEMAP = 'SET_PRIVILEGEMAP';
